/**
 * Contact page form submit.
 */
(() => {
  const form = document.getElementById('contact-form');
  const status = document.getElementById('contact-status');
  if (!form || !status) return;

  const submitButton = form.querySelector('button[type="submit"]');

  const setStatus = (message, kind) => {
    status.textContent = message;
    status.classList.remove('hidden', 'text-red-600', 'text-green-700', 'text-slate-500');
    if (kind === 'error') status.classList.add('text-red-600');
    else if (kind === 'success') status.classList.add('text-green-700');
    else status.classList.add('text-slate-500');
  };

  form.addEventListener('submit', async (e) => {
    e.preventDefault();

    const name = form.querySelector('[name="name"]')?.value?.trim() || '';
    const email = form.querySelector('[name="email"]')?.value?.trim() || '';
    const message = form.querySelector('[name="message"]')?.value?.trim() || '';
    const turnstileToken = form.querySelector('[name="cf-turnstile-response"]')?.value || '';

    if (!name || !email || !message) {
      setStatus('Please complete all fields.', 'error');
      return;
    }
    if (!turnstileToken) {
      setStatus('Please complete the verification challenge.', 'error');
      return;
    }

    if (submitButton) {
      submitButton.disabled = true;
      submitButton.textContent = 'Sending...';
    }
    setStatus('Sending message...', 'muted');

    try {
      const resp = await fetch('/api/contact', {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ name, email, message, turnstile_token: turnstileToken }),
      });
      const data = await resp.json().catch(() => ({}));
      if (!resp.ok || !data.ok) {
        throw new Error(data.error || 'Message could not be sent.');
      }

      form.reset();
      if (window.turnstile) window.turnstile.reset();
      setStatus('Message sent. We will reply by email.', 'success');
    } catch (err) {
      if (window.turnstile) window.turnstile.reset();
      setStatus(err instanceof Error ? err.message : 'Message could not be sent.', 'error');
    } finally {
      if (submitButton) {
        submitButton.disabled = false;
        submitButton.textContent = 'Send Message';
      }
    }
  });
})();
